import { __assign } from "tslib";
// MO4.1.2
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import Flex from '@wix/da-ds/pkg/Flex';
import StatisticsBar from '../Helper/StatisticsBar';
import UserIdentity from '../../User/Identity';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import DeviationDumbView from '../Dumbo';
import UnknownDumbo from '../Dumbo/Unknown';
import Minimal from './Minimal';
import s from './TierPromotionCardDumb.scss';
var RATIO = 1.84;
var DESCRIPTION_CUTOFF_HEIGHT = 250;
var STATS_CUTOFF_HEIGHT = 195;
var MINIMAL_VIEW_HEIGHT = 120;
var DUMBO_MAX_WIDTH_RATIO = 0.33;
function getDimensions(width, height) {
    if (width) {
        return { width: width, height: width / RATIO };
    }
    else if (height) {
        return { width: height * RATIO, height: height };
    }
}
function getDumboHeight(cardHeight) {
    // spacings =  4 * 16px
    // footer block = 32px
    // borders = 2px
    return cardHeight - 4 * 16 - 32 - 2;
}
var TierPromotionCardDumb = function (_a) {
    var title = _a.title, description = _a.description, author = _a.author, _b = _a.showAuthor, showAuthor = _b === void 0 ? true : _b, numSubscribers = _a.numSubscribers, price = _a.price, coverImage = _a.coverImage, showMatureCover = _a.showMatureCover, hotspot = _a.hotspot, ctaButton = _a.ctaButton, width = _a.width, height = _a.height, style = _a.style, showEmptyPlaceholders = _a.showEmptyPlaceholders, _c = _a.state, state = _c === void 0 ? 'active' : _c, className = _a.className, onClick = _a.onClick, innerRef = _a.innerRef;
    var t = useTranslation().t;
    var dimensions = getDimensions(width, height);
    if (!dimensions) {
        return null;
    }
    if (dimensions.height <= MINIMAL_VIEW_HEIGHT) {
        return (React.createElement(Minimal, __assign({ deviation: coverImage, className: classnames(s['root'], className), onClick: onClick }, dimensions, { style: style })));
    }
    var stats = [
        numSubscribers !== undefined && {
            icon: TierIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers,
            }),
        },
    ].filter(function (stat) { return stat; });
    var showDescription = description && dimensions.height >= DESCRIPTION_CUTOFF_HEIGHT;
    var showStats = stats.length > 0 && dimensions.height >= STATS_CUTOFF_HEIGHT;
    var dumboWidth = dimensions.width * DUMBO_MAX_WIDTH_RATIO;
    var dumboHeight = getDumboHeight(dimensions.height);
    return (React.createElement("div", { className: classnames(s['root'], s['root-with-details'], className), style: __assign(__assign({}, dimensions), style), onClick: onClick, ref: innerRef },
        React.createElement(Flex, { className: s['details-and-thumb'], style: { maxHeight: dumboHeight } },
            React.createElement("div", { className: s['card-details'] },
                showAuthor && author && (React.createElement(UserIdentity, { user: author, size: "small", className: s['identity'] })),
                showEmptyPlaceholders && !title && (React.createElement("div", { className: classnames(s['placeholder'], s['placeholder-title']) })),
                title && React.createElement("div", { className: s['title'] }, title),
                showStats && (React.createElement(StatisticsBar, { className: s['statistics'], stats: stats })),
                showDescription && (React.createElement("div", { className: s['description'] }, description)),
                hotspot),
            React.createElement("div", { className: s['dumbo-wrapper'] },
                coverImage ? (React.createElement(DeviationDumbView, { className: s['dumbo'], deviation: coverImage, width: dumboWidth, height: dumboHeight, showMatureContent: showMatureCover })) : showEmptyPlaceholders ? (React.createElement("div", { className: s['placeholder-cover'], style: { width: dumboWidth, height: dumboHeight } })) : (React.createElement(UnknownDumbo, { className: s['dumbo'], width: dumboWidth, height: dumboHeight })),
                state !== 'active' && (React.createElement("div", { className: classnames(s['state-tag'], s[state]) }, t("deviationview.tierCard.state.".concat(state)))))),
        React.createElement("hr", { className: s['divider'] }),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: price, showPlaceholder: showEmptyPlaceholders }),
            ctaButton)));
};
TierPromotionCardDumb.displayName = 'TierPromotionCardDumb';
export default TierPromotionCardDumb;
//# sourceMappingURL=TierPromotionCardDumb.js.map